module.exports = __webpack_public_path__ + "static/media/distribuicao-tour.fbb7df19.jpg";